export default {
  path: "/cancro",
  name: "Cancro",
  component: () => import("../pages/index.vue")
};
